import { render, staticRenderFns } from "./SubtitlesStage.vue?vue&type=template&id=53d6099f&"
import script from "./SubtitlesStage.vue?vue&type=script&lang=js&"
export * from "./SubtitlesStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports